var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsPythonFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:python-fill",
    clipPath: "url(#clip0_5_25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_25",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akarIconsPythonFill0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H120V120H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.57 0C29.1 0 31 13.28 31 13.28L31.035 27.04H60.105V31.17H19.5C19.5 31.17 0 28.945 0 59.845C0 90.745 17.015 89.645 17.015 89.645H27.165V75.31C27.165 75.31 26.62 58.21 43.915 58.21H72.745C72.745 58.21 88.945 58.47 88.945 42.47V16.01C88.945 16.01 91.405 0 59.57 0ZM43.54 9.25C46.43 9.25 48.77 11.6 48.77 14.51C48.77 17.415 46.43 19.765 43.54 19.765C40.645 19.765 38.31 17.415 38.31 14.51C38.31 11.6 40.645 9.25 43.54 9.25Z",
    fill: "#FE6E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M60.435 120C90.895 120 88.995 106.72 88.995 106.72L88.96 92.96H59.89V88.83H100.505C100.505 88.83 120.005 91.055 120.005 60.155C120.005 29.255 102.985 30.355 102.985 30.355H92.835V44.69C92.835 44.69 93.38 61.79 76.085 61.79H47.26C47.26 61.79 31.06 61.53 31.06 77.53V103.99C31.06 103.99 28.6 120 60.435 120ZM76.465 110.75C73.57 110.75 71.235 108.4 71.235 105.49C71.235 102.585 73.57 100.235 76.465 100.235C79.355 100.235 81.695 102.585 81.695 105.49C81.695 108.4 79.355 110.75 76.465 110.75Z",
    fill: "#FE6E00"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsPythonFill);
export default __webpack_public_path__ + "static/media/akar-icons-python-fill.6156c22daec1ecb959f343897b2086c7.svg";
export { ForwardRef as ReactComponent };